import React from 'react'
import {Link} from 'react-router-dom'

import withSlider from '../hoc/with-slider'

const SimilarProductsSlider = ({
                                 index, images, isViewedArrow, handleArrowClick, updateSliderBackgrounds,
                                 updateSliderComponentData
                               }) => {
  const itemList = images.map((_, i) => {
    if (i > 2) {
      return null
    }
    const currentItem = index + i - 1;
    const id = updateSliderComponentData(currentItem).id;

    return (
      <div className="similar-products-slider__item-list__item-card item" key={id}>
        <div className="similar-products-slider__item" style={updateSliderBackgrounds(currentItem)}>
          <Link to={`/product-card-desktop/${id}`}/>
        </div>
        <div className="similar-products-slider__item-desc">
          <h4 className="similar-products-slider__item-name">{updateSliderComponentData(currentItem).title}</h4>
          <p className="similar-products-slider__item-producer">Производитель: <span
            className="producer">{updateSliderComponentData(index + i).brand}</span>
          </p>
          <p className="similar-products-slider__item-price">
            {updateSliderComponentData(currentItem).price.toLocaleString('ru-RU')}
          </p>
        </div>
      </div>
    )
  });

  return (
    <div className="similar-products-slider">
      {isViewedArrow && <div className="similar-products-slider__arrow similar-products-slider__arrow_left arrow"
                             onClick={handleArrowClick}/>}
      {itemList}
      {isViewedArrow && <div className="similar-products-slider__arrow similar-products-slider__arrow_right arrow"
                             onClick={handleArrowClick}/>}
    </div>
  )
};

export default withSlider(SimilarProductsSlider)
